export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/comic_cartoon.ec45189.png";